module.exports = __webpack_public_path__ + "img/cl.6d63ff70.svg";